<script>
    import MediaPreviewPdf from './MediaPreviewPdf';

    export default {
        components: {
            MediaPreviewPdf
        },
        props: {
            media: Object,
            formatList: Array,
            imageCacheTime: String,
        },
        data() {
            return {
                show: false,
            }
        },
        methods: {
            hasFormat(format) {
                return _.includes(this.formatList, format);
            },
            getFormat(format) {
                return _.replace(this.media.imageUrl, 'ORIGINAL', format);
            },
            pauseVideoIfStillRunning() {
                if (this.$refs.videoPlayer && !this.$refs.videoPlayer.player.paused()) {
                    this.$refs.videoPlayer.player.pause();
                }
            },
        },
        computed: {
            isPdf() {
                let mb_limit = 10;

                return this.media.type === 'pdf' && this.media.filesize < (mb_limit*1024*1024);
            },
            previewUrl() {
                if (this.hasFormat('SCOOP_OS_BIG')) {
                    return this.media.bigPreviewImageUrl + '&t=' + this.imageCacheTime;
                }

                return this.media.previewImageUrl + '&t=' + this.imageCacheTime;
            }
        }
    }
</script>

<template>
    <Lightbox
            id="previewImageBig"
            :headline="__('scoop-os.media.preview_image_headline')"
            css-class="inline"
            class="inline"
            @lightboxopening="show = true"
            @lightboxclosing="pauseVideoIfStillRunning"
    >
        <span slot="open-template">
            <div>
                <span v-if="media.failed_validations && media.failed_validations.length"
                      class="label inside label-warning">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
                <img alt="" class="img-responsive pull-right" :src="media.previewImageUrl + '&t=' + imageCacheTime">
            </div>
        </span>
        <div slot="body" class="text-center" v-if="show">
            <div v-if="hasFormat('SCOOP_OS_COMPILED_VIDEO')">
                <video-player
                        :src="getFormat('SCOOP_OS_COMPILED_VIDEO')"
                        :autoplay="false"
                        class="full-width"
                        ref="videoPlayer"
                />
            </div>
            <media-preview-pdf v-else-if="isPdf" :src="media.imageUrl"/>
            <img
                    v-else alt=""
                    style="margin: auto;"
                    class="img-responsive"
                    :src="previewUrl"
            >
        </div>
        <div v-cloak slot="footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">{{
                __('scoop-os.media.preview_image_close_btn') }}
            </button>
        </div>
    </Lightbox>
</template>
